import React from 'react';
import { useDebouncedCallback } from '@tanstack/react-pacer';

import Pipeline from 'types/pipeline';

import { usePipelines, UsePipelinesParams } from 'pipelines/hooks/usePipelines';

import { Select, SelectProps } from 'components/Select/Select';

export type PipelineSelectProps<IsMulti extends boolean = false> = SelectProps<
  Pipeline,
  IsMulti
> & {
  queryFilters?: UsePipelinesParams;
};

export function PipelineSelect<IsMulti extends boolean = false>({
  placeholder = 'Workflow',
  isLoading,
  queryFilters = {},
  ...props
}: PipelineSelectProps<IsMulti>) {
  const [filters, setFilters] = React.useState<UsePipelinesParams>({});

  const { data, isLoading: isLoadingOptions } = usePipelines({
    params: { ...queryFilters, ...filters },
    keepPreviousData: true,
  });

  const handleInputChange = useDebouncedCallback(
    (value: string) => {
      setFilters((previousFilters) => ({
        ...previousFilters,
        pipeline_names: [value],
      }));
    },
    { wait: 100 }
  );

  return (
    <Select
      {...props}
      options={data?.data}
      totalElements={data?.total_elements}
      onInputChange={handleInputChange}
      placeholder={placeholder}
      getOptionLabel={({ name }) => name}
      getOptionValue={({ id }) => id}
      isLoading={isLoading || isLoadingOptions}
    />
  );
}
